/** The sun shadows of buildings and trees, under everything standing (render/lighting.ts). */
import { drawSceneryShadows, lightingOn } from '../lighting';
import { registerRenderPass } from './registry';

registerRenderPass({
  id: 'sceneryShadows',
  layer: 'ground',
  order: 300,
  draw(f) {
    if (f.outdoors && lightingOn())
      drawSceneryShadows(f.g, f.outdoors.props.props, f.ox, f.oy, f.W, f.H, f.world.hour);
  },
});
